import * as Yup from "yup";
import React, { Fragment, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import {
  Alert,
  Box,
  FormHelperText,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Link } from "react-router-dom";
import { MuiOtpInput } from "mui-one-time-password-input";
import { useSnackbar } from "../../snackbar";
import Iconify from "../../iconify";
import Grid from "@mui/material/Grid";
// import { data } from "flickity";

export default function EmailIntegration() {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const AUTHENTIK_LOGIN_URL = `${SERVER_URI}/ssologin`;
  const SEND_OTP_NUM = `${SERVER_URI}/sendOtpByMobile`;
  const VERIFY_OTP_NUM = `${SERVER_URI}/verifyOtpByMobile`;
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [emailData, setEmailData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false); // To track OTP state
  const [savedEmail, setSavedEmail] = useState("");
  const [isResendDisabled, setIsResendDisabled] = React.useState(true);
  const [resendTimer, setResendTimer] = React.useState(60);

  const startResendTimer = () => {
    setIsResendDisabled(true);
    setResendTimer(60);
    const timerInterval = setInterval(() => {
      setResendTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(timerInterval);
          setIsResendDisabled(false);
        }
        return prevTimer - 1;
      });
    }, 1000);
  };
  const UpdateEmailSchema = Yup.object().shape({
    // email: Yup.string()
    //   .required("Email is required")
    //   .matches(
    //     /^[a-zA-Z0-9._+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    //     "Email must be a valid email address"
    //   ),

    // email: Yup.string()
    // .required("Email is required")
    // .matches(
    //   /^[a-zA-Z0-9._+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    //   "Email must be a valid email address"
    // )
    // .test(
    //   "is-allowed-domain",
    //   "Email domain must be one of the following: gmail.com, yahoo.com, outlook.com, protonmail.com, hotmail.com, zoho.com",
    //   (value) => {
    //     if (!value) return false;
    //     const domain = value.split("@")[1];
    //     return ["gmail.com", "yahoo.com", "outlook.com", "protonmail.com","mail.com","zoho.com","megaconnect.cloud"].includes(domain);
    //   }
    // ),

    mobile: Yup.string()
    .min(10, "Mobile number must be at least 10 digits")
    .required("Mobile number is required")
    .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits")
   ,
    otp: Yup.string()
      .min(6, "OTP must be at least 6 characters")
      .matches(
        /^\d{6}$/,
        "OTP must be exactly 6 digits and contain only numbers"
      )
      .required("OTP is required"),
  });

  const defaultValues = {
    mobile: emailData?.email || "",
    otp: emailData?.otp || "",
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
    getValues,
    trigger,
    setValue,
    setError,
    reset,
  } = useForm({
    resolver: yupResolver(UpdateEmailSchema),
    defaultValues,
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const sendOtp = async () => {
    const isMobileValid = await trigger("mobile");
    // Trigger validation for the email field
    if (!isMobileValid) {
      setErrorMessage("Please enter a valid mobile Number.");
      return;
    }
    const mobileNumber = getValues("mobile");
    setLoading(true);
    // console.log(email);
    try {
      const response = await axios.post(SEND_OTP_NUM, { mobileNumber });
      setOtpSent(true);
      startResendTimer();
      enqueueSnackbar(response.data.message, { variant: "success" });
      setValue("otp", "");
    } catch (error) {
      // console.log("error response", error.response.data.message);
      if (error.response && error.status === 400) {
        setError("mobile", {
          type: "manual",
          message: error.response.data.message, // Display server error message
        });
      } else if (error.response && error.response.status === 500) {
        setError("mobile", {
          type: "manual",
          message: "Server error occurred. Please try again later.",
        });
      } else {
        setErrorMessage("An unexpected error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };
  // let token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJodHRwczovL3Nzby5tZWdhY29ubmVjdC5jbG91ZC9hcHBsaWNhdGlvbi9vL3RlY2htZWdhLXNzby8iLCJzdWIiOiI2NzBlMTIyOGIwZjU5ZGYwZDcyMmJjMTYiLCJhdWQiOiJsbHltb2pwRlpqNllWcVRlZHVlZzE4NGFWNlZQQVQwaUpNcEViY3N0IiwiZXhwIjoxNzI5MDYxODAwLCJpYXQiOjE3Mjg5NzU0MDAsImF1dGhfdGltZSI6MTcyODk3NTQwMCwiYWNyIjoiZ29hdXRoZW50aWsuaW8vcHJvdmlkZXJzL29hdXRoMi9kZWZhdWx0IiwiZW1haWwiOiJyYXZpb3Vyc2FuZzAyN0BnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiYXpwIjoibGx5bW9qcEZaajZZVnFUZWR1ZWcxODRhVjZWUEFUMGlKTXBFYmNzdCIsInVpZCI6IjY3MGUxMjI4YjBmNTlkZjBkNzIyYmMxNiJ9.VmI9g3VsbQaZ3M0i04UYLZT1ZxPTh4x4Z1-T58rkK4g";
  // let config = {
  //   headers: { Authorization: `Bearer ${token}` },
  // };
  // Function to verify OTP
  const verifyOtp = async (data) => {
    setLoading(true);
    const isMobileValid = await trigger("mobile");
    const isOtpValid = await trigger("otp");
    // Trigger validation for the email field
    if (!isMobileValid) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }
    if (!isOtpValid) {
      setErrorMessage("Please enter a valid OTP.");
      return;
    }
    const mobileNumber = getValues("mobile");
    const otp = getValues("otp");
    setLoading(true);
    // console.log(email);
    try {
      const response = await axios.post(VERIFY_OTP_NUM, { mobileNumber, otp });
      // console.log(response.data)
      enqueueSnackbar(response.data.message, { variant: "success" });
      sessionStorage.setItem("temptoken", response.data.temptoken)
      setTimeout(() => {
        navigate("/user_pass"); // Adjust the path as necessary
      }, 3000);
      sessionStorage.removeItem("formData");
    } catch (error) {
      setErrorMessage("OTP verification failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const onSubmit = async (data) => {
    // console.log("Form Submitted:", data);
    if (!otpSent) {
      // If OTP is not sent yet, send OTP
      await sendOtp();
    } else {
      // If OTP is sent, verify the OTP
      await verifyOtp();
    }
  };
  return (
    <Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack direction="column" spacing={4} sx={{ mt: 8, mb: 8 }}>
          <Box>
            <Stack direction="column">
              <Typography
                variant="h3"
                sx={{
                  color: "#1D53E7",
                  fontFamily: "Sofia Sans Extra Condensed",
                  fontWeight: 700,
                }}
              >
                SIGN UP NOW{" "}
              </Typography>
              {/* <Typography
                                sx={{
                                    fontSize: 18,
                                    fontFamily: "Roboto Flex",
                                    fontWeight: "400",
                                    wordWrap: "break-word",
                                }}
                            >
                                Where Your Digital Universe Unfolds!
                            </Typography> */}
            </Stack>
          </Box>
          <Box>
            <Stack direction="column" spacing={1}>
              <Typography
                component="label"
                htmlFor="mobile_text"
                sx={{
                  fontWeight: 400,
                  fontFamily: "Roboto Flex",
                  fontSize: "18px",
                  color: "#1F1F1F",
                }}
              >
                Enter Mobile Number
              </Typography>
              <Controller
                name="mobile"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    id="mobile_text"
                    variant="outlined"
                    size="medium"
                    fullWidth
                    error={!!errors.mobile}
                    helperText={errors.mobile?.message}
                    // fontFamily='Roboto Flex'
                    // fontSize='18px'
                    // color="#1D53E7"
                    // disabled={otpSent}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 3,
                      },
                    }}
                  />
                )}
              />
            </Stack>
          </Box>
          {otpSent && (
            <Box>
              <Stack direction="column" spacing={1} mb={2}>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "18px",
                    fontFamily: "Roboto Flex",
                  }}
                >
                  OTP Verification
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontFamily: "Roboto Flex",
                    fontWeight: "300",
                    wordWrap: "break-word",
                    color: "GrayText",
                  }}
                >
                  We've sent you an OTP to your email. Please enter the code
                  below to proceed.
                </Typography>
              </Stack>
              <Controller
                name="otp"
                control={control}
                render={({ field }) => (
                  <div>
                    <MuiOtpInput
                      {...field}
                      autoFocus
                      gap={{ xs: 1.5, lg: 3.5 }}
                      length={6}
                      TextFieldsProps={{
                        //   error: !!error,
                        // placeholder: "-",
                        error: !!errors.otp,
                        variant: "outlined",
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 3,
                        },
                      }}
                    />

                    {errors.otp && (
                      <FormHelperText sx={{ px: 2 }} error>
                        {errors.otp?.message}
                      </FormHelperText>
                    )}
                  </div>
                )}
              />
              {errorMessage && (
                <Alert
                  variant="outlined"
                  severity="error"
                  sx={{ mt: 1, borderRadius: 3 }}
                  action={
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={() => {
                        setErrorMessage(null);
                      }}
                    >
                      <Iconify color="red" icon="basil:cross-outline" />
                    </IconButton>
                  }
                >
                  {errorMessage}
                </Alert>
              )}
            </Box>
          )}
          <Box>
            <Stack
              direction={{ xs: "column", md: "row" }}
              spacing={3}
              sx={{ textAlign: "center", alignItems: "center" }}
            >
              {otpSent && (
                <LoadingButton
                  size="large"
                  sx={{
                    fontFamily: "Roboto Flex",
                    width: "150px",
                    backgroundColor: "#C7F760",
                    color: "#1E53E8",
                    textTransform: "none",
                    fontWeight: 900,
                    "&:hover": {
                      backgroundColor: "#1E53E8",
                      color: "#C7F760",
                    },
                  }}
                  type="submit"
                  loading={loading}
                  variant="contained"
                >
                  Verify OTP
                </LoadingButton>
              )}
              {otpSent && (
                <Typography
                  onClick={() => {
                    if (!isResendDisabled) {
                      sendOtp(); // Only call sendOtp when isResendDisabled is false
                    }
                  }}
                  sx={{
                    fontFamily: "Roboto Flex",
                    fontWeight: 700,
                    width: "150px",
                    color: isResendDisabled ? "#b0b0b0" : "#1E53E8",
                    textAlign: { xs: "center", md: "left" },
                    cursor: isResendDisabled ? "not-allowed" : "pointer",
                    textDecoration: "none",

                    "@media (max-width: 600px)": { width: "100%" },
                  }}
                >
                  {isResendDisabled
                    ? `Resend OTP (${resendTimer}s)`
                    : "Resend OTP"}
                </Typography>
              )}
              {!otpSent && (
                <LoadingButton
                  size="large"
                  sx={{
                    fontFamily: "Roboto Flex",
                    width: "150px",
                    backgroundColor: "#C7F760",
                    color: "#1E53E8",
                    textTransform: "none",
                    fontWeight: 900,
                    "&:hover": {
                      backgroundColor: "#1E53E8",
                      color: "#C7F760",
                    },
                  }}
                   type="submit"
                  loading={loading}
                  variant="contained"
                  onClick={() => {
                    sendOtp();
                  }}
                >
                  Send OTP
                </LoadingButton>
              )}
              {!otpSent && (
                <Typography
                  sx={{
                    // display: "flex",
                    fontSize: 16,
                    fontFamily: "Roboto Flex",
                    fontWeight: "400",
                    wordWrap: "break-word",
                    textAlign: "center",
                    alignItems: "center",
                  }}
                >
                  Already have an account?{" "}
                  <Link
                    to="/user_Login"
                    style={{ color: "#1E53E8" }}
                    // onClick={() => window.open(AUTHENTIK_LOGIN_URL, "_self")}
                  >
                    Log in
                  </Link>
                </Typography>
              )}
            </Stack>
          </Box>
        </Stack>
      </form>
    </Fragment>
  );
}
